import React, {
    useContext, useEffect, useMemo,
} from 'react';
import {
    gql, useQuery, useMutation, useReactiveVar,
} from '@apollo/client';
import {
    abTestDataContext,
    NEW_MOBILE_MENU,
} from 'app/containers/contexts/abTest.context';
import { isDesktop } from 'app/utils/resolution';

import { STORE_ENV_DATA } from 'app/graphql/network/envDataMutation';
import { idGenerator } from 'app/utils/classes/uniqueIdGenerator';
import { selectedPeriodVar } from 'app/apollo/reaction';

const participantId = idGenerator.generateId();

const testsForAuthourizedUsers: any[] = [
    // NEW_MOBILE_MENU
];

export const useParticipantIdABTest = (
    testName: string,
    testGroupValue: string,
    fallbackTestGroupValue?: string,
) => {
    const abTestContext: any = useContext(abTestDataContext);
    const period = useReactiveVar(selectedPeriodVar);

    const testValue = abTestContext[testName];
    const { fetchABTestValue, setABTestValue } = abTestContext;

    const [storeEnvData] = useMutation(STORE_ENV_DATA);

    const USER_AB_GROUPS_QUERY = gql`
        query USER_AB_GROUPS_QUERY {
                user {
                    id
                    ab_groups
                }
            }
        `;

    const { data: { user } } = useQuery(USER_AB_GROUPS_QUERY, {
        fetchPolicy: 'cache-first',
    });

    const isUserInABTestAlready = useMemo(
        () => user?.ab_groups?.some((group: string) => group.includes(testValue)),
        [user?.ab_groups, testValue],
    );

    const isNeedToFetchABTest = useMemo(
        () => {
            if (isUserInABTestAlready) return false;
            const testForAuthourizedUsers = testsForAuthourizedUsers.includes(testName);
            if (testForAuthourizedUsers) {
                return testValue === 'unfetched' && !isDesktop() && Boolean(user);
            }
            return testValue === 'unfetched' && !isDesktop();
        },
        [testValue, testName, user, isUserInABTestAlready],
    );
    // console.log({
    //     testName,
    //     testGroupValue,
    //     fallbackTestGroupValue,
    //     testValue,
    //     isNeedToFetchABTest,
    // });

    const hasParticipantId = useMemo(
        () => Boolean(sessionStorage.getItem('participantId')),
        [],
    );

    useEffect(
        () => {
            if (isNeedToFetchABTest) {
                if (fallbackTestGroupValue) {
                    setABTestValue(testName, fallbackTestGroupValue);
                } else {
                    fetchABTestValue(testName);
                }
            }
        },
        [
            isNeedToFetchABTest,
            setABTestValue, fetchABTestValue,
            fallbackTestGroupValue, testName,
        ],
    );

    useEffect(
        () => {
            if (
                testValue !== 'unfetched'
                && !isUserInABTestAlready
                && !hasParticipantId
            ) {
                storeEnvData({
                    variables: {
                        participantId,
                        period,
                    },
                })
                    .then(
                        () => sessionStorage.setItem('participantId', participantId as string),
                    );
            }
        },
        [
            testValue,
            isUserInABTestAlready,
            hasParticipantId,
            period,
            storeEnvData,
        ],
    );

    return [testValue === testGroupValue];
};
